"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var Header_1 = __importDefault(require("./Header"));
var Content_1 = __importDefault(require("./Content"));
var ComponentContainer = function (props) {
    var iconProps = props.iconProps, title = props.title, action = props.action, noPadding = props.noPadding;
    return (react_1.default.createElement("div", { className: "component_wrapper" },
        props.noHeader
            ? null
            : react_1.default.createElement(antd_1.Row, { align: "stretch" },
                react_1.default.createElement(antd_1.Col, { span: 24 },
                    react_1.default.createElement(Header_1.default, { iconProps: iconProps, title: title, action: action }))),
        react_1.default.createElement(antd_1.Row, null,
            react_1.default.createElement(antd_1.Col, { span: 24, className: "" + (noPadding ? '' : 'component_wrapper_padding') },
                react_1.default.createElement(Content_1.default, null, props.children)))));
};
exports.default = ComponentContainer;
